import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { AssetCategoriesService } from "../../asset-categories.service";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAssetCategory } from "../../models/assets";

@Component({
  selector: "app-asset-categories",
  templateUrl: "./asset-categories.component.html",
  styleUrls: ["./asset-categories.component.scss"],
})
export class AssetCategoriesComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public categoriesList: IAssetCategory[] = [];
  public currentCategory: IAssetCategory;
  public newCategory: string = "";
  public newCategoryDescription: string = "";
  public pageBasicText: number = 1;
  public pageSize: number = 10;
  public isAChild: boolean = false;
  public selectedAsAParent: number;
  public showModalErrors: boolean = false;

  constructor(
    public _assetCategoriesService: AssetCategoriesService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _router: Router,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.ASSET_CATEGORIES",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "ASSETS",
            isLink: true,
            link: "/dashboard/assets/list",
          },
          {
            name: "MENU.ASSET_CATEGORIES",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_categories_asset")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this.loadCategories();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadCategories() {
    this.categoriesList = await this._assetCategoriesService.getCategoriesList();
  }

  categoriesFilterList() {
    let items = this.categoriesList;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.categoriesList.filter((item: IAssetCategory) => item.name.toLowerCase().includes(keywords));
    }
    return items;
  }

  public modalOpen(whichModal, assetCategory) {
    if (assetCategory && assetCategory.parent_id && assetCategory.parent_id > 0) {
      assetCategory.isAChild = 1;
    }
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
    this.selectedAsAParent = null;
    this.newCategory = "";
    this.newCategoryDescription = "";
    this.isAChild = false;
    this.currentCategory = JSON.parse(JSON.stringify(assetCategory));
    this.showModalErrors = false;
  }

  async deleteCategory(currentCategory) {
    if (!this._authenticationService.hasCapability("delete_asset_category")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCategory.name;
    if (currentCategory) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._assetCategoriesService
            .deleteCategory(currentCategory.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadCategories();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_ASSET_CATEGORY_REMOVE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    }
    await this.loadCategories();
  }

  async addCategory() {
    if (!this._authenticationService.hasCapability("create_asset_category")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.newCategory) {
      this.newCategory = this.newCategory.trim();
    }

    if (!this.newCategory || this.newCategory.length < 1 || (!!this.newCategory && this.newCategory.length < 2)) {
      this.showModalErrors = true;
      return false;
    }
    if (this.isAChild && (!this.selectedAsAParent || this.selectedAsAParent < 1)) {
      this.showModalErrors = true;
      return false;
    }
    this._utilService.showLoading();
    await this._assetCategoriesService
      .createCategory({
        name: this.newCategory,
        description: this.newCategoryDescription && this.newCategoryDescription.length > 3 ? this.newCategoryDescription : null,
        parent_id: this.isAChild ? this.selectedAsAParent : null,
      })
      .then(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_ADD_ASSET_CATEGORY" });
        this._modalService.dismissAll();
        this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_ADD_ASSET_CATEGORY" });
      });
  }

  async editCategory() {
    if (!this._authenticationService.hasCapability("edit_asset_category")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentCategory.name) {
      this.currentCategory.name = this.currentCategory.name.trim();
    }

    if (!this.currentCategory.name || this.currentCategory.name.length < 1 || (!!this.currentCategory.name && this.currentCategory.name.length < 2)) {
      this.showModalErrors = true;
      return false;
    }

    if (this.currentCategory.isAChild && (!this.currentCategory.parent_id || this.currentCategory.parent_id < 1)) {
      this.showModalErrors = true;
      return false;
    }

    if (this.currentCategory.isAChild === false) {
      this._utilService.showLoading();
      await this._assetCategoriesService
        .updateCategory(this.currentCategory.id, {
          name: this.currentCategory.name,
          description: this.currentCategory.description,
          parent_id: null,
        })
        .then(async () => {
          this._utilService.hideLoading();
          this._modalService.dismissAll();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ASSET_CATEGORY" });
          await this.loadCategories();
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_EDIT_ASSET_CATEGORY" });
        });
    } else {
      this._utilService.showLoading();
      await this._assetCategoriesService
        .updateCategory(this.currentCategory.id, {
          name: this.currentCategory.name,
          description: this.currentCategory.description && this.currentCategory.description.length > 3 ? this.currentCategory.description : null,
          parent_id: this.currentCategory && this.currentCategory.parent_id && this.currentCategory.parent_id > 0 ? this.currentCategory.parent_id : null,
        })
        .then(async () => {
          this._utilService.hideLoading();
          this._modalService.dismissAll();
          await this.loadCategories();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ASSET_CATEGORY" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_EDIT_ASSET_CATEGORY" });
        });
    }
  }
}
